import axios from "axios";
import { API_URL } from "../config/endpoints";
export function loginWithPassword(formData) {
  return new Promise((resolve, reject) => {
    axios
      .post(`${API_URL}auth/login`, formData)
      .then(async (response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export function postTasks(formData) {
  return new Promise((resolve, reject) => {
    axios
      .post(`${API_URL}api/user/data`, formData)
      .then(async (response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export function deleteRoadMapService(id) {
  return new Promise((resolve, reject) => {
    axios
      .delete(`${API_URL}api/user/data/${id}`)
      .then(async (response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export function getTasks(id) {
  return new Promise((resolve, reject) => {
    axios
      .post(`${API_URL}api/user/alldata`, id)
      .then(async (response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export async function getTaskById(id) {
  return new Promise((resolve, reject) => {
    axios
      .get(`${API_URL}api/user/data/${id}`, {
        headers: {
          //   Authorization: `JWT ${token}`
        }
      })
      .then(async (response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export function putRoadmap(id, formData) {
  return new Promise((resolve, reject) => {
    axios
      .put(`${API_URL}api/user/data/${id}`, formData)
      .then(async (response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}
export function getAllData(data) {
  return new Promise((resolve, reject) => {
    axios.get(`${API_URL}api/getAllData`, data).then(async (response) => {
      resolve(response);
    }).catch((err) => {
      reject(err)
    })
  })
}

export function membersSearch(data, email) {
  return new Promise((resolve, reject) => {
    axios.post(`${API_URL}api/getAllUsers/${email}`, data).then(async (response) => {
      resolve(response);
    }).catch((err) => {
      reject(err)
    })
  }
  )
}
export function uploadfile(formData) {
  return new Promise((resolve, reject) => {
    axios
      .post(`${API_URL}api/upload`, formData)
      .then(async (response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export function todoTask(payload) {
  console.log('payload data', payload);
  return new Promise((resolve, reject) => {
    axios
      .post(`${API_URL}api/createTask`, payload)
      .then(async (response) => {
        resolve(response.data);
      })
      .catch((err) => { reject(err) })
  })
}
export function getTask(data) {
  return new Promise((resolve, reject) => {
    axios.post(`${API_URL}api/getTask`, data).then(async (response) => {
      resolve(response);
    }).catch((error) => {
      reject(error);
    })
  })

}

export function deleteTask(task) {
  return new Promise((resolve, reject) => {
    axios.post(`${API_URL}api/deleteTask`, task).then(async (response) => {
      resolve(response);
    }).catch((error) => {
      reject(error);
    })
  })
}

export function updateTask(id) {
  return new Promise((resolve, reject) => {
    axios.put(`${API_URL}api/updateTask`, id).then(async (response) => {
      resolve(response)
    }).catch((error) => {
      reject(error);
    })
  })
}
